import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sourceLatLng: "",
  destinationLatLng: "",
  address: "",
  place_id: "",
  pickup: "",
  dropoff: "",
  dateOfJourney: null,
  timeOfJourney: null,
  NumberOfPassenger: "1 passenger",
  currency: "",
  duration: "",
  isOneway: true,
  isSearchingprice: false,
  routePricingData: {},

  isLoading: false,
  isError: false,
  isLoaded: false,

  currentSearchMode: "ONEWAY",

  pickup: {
    lat: null,
    lng: null,
    address: "",
    place_id: "",
  },
  dropof: {
    lat: null,
    lng: null,
    address: "",
    place_id: "",
  },
  hour: 0,
};

const routePricingSlice = createSlice({
  name: "routePricing",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.isError = action.payload.isError;
      state.isLoading = action.payload.isLoading;
      state.isLoaded = action.payload.isLoaded;
    },
    resetroutePricingData: (state) => {
      state.routePricingData = {};
    },
    setHour: (state, action) => {
      state.hour = action.payload.hour;
    },
    setPickUp: (state, action) => {
      // shape of payload
      // {
      //   lat: null,
      //   lng: null,
      //   address: "",
      //   place_id: "",
      // }
      state.pickup = { ...action.payload };
    },
    setDropof: (state, action) => {
      // shape of payload
      // {
      //   lat: null,
      //   lng: null,
      //   address: "",
      //   place_id: "",
      // }
      state.dropof = { ...action.payload };
    },
    setRoutePricingDataOW: (state, action) => {
      state.routePricingData = action.payload.routePricingData;
    },
    setRoutePricingDataHR(state, action) {
      state.routePricingData = action.payload.routePricingData;
    },
    getSourceLatLng(state, action) {
      state.sourceLatLng = action.payload.sourceLatLng;
    },
    getDestinationLatLng(state, action) {
      state.destinationLatLng = action.payload.destinationLatLng;
    },
    setDateOfJourney(state, action) {
      state.dateOfJourney = action.payload.dateOfJourney;
    },
    setTimeOfJourney(state, action) {
      state.timeOfJourney = action.payload.timeOfJourney;
    },
    setNumberOfPassenger(state, action) {
      state.NumberOfPassenger = action.payload.NumberOfPassenger;
    },
    getCurrency(state, action) {
      state.currency = action.payload.currency;
    },
    getDuration(state, action) {
      state.duration = action.payload.duration;
    },
    setisSearchingprice(state, action) {
      state.isSearchingprice = action.payload.setisSearchingprice;
    },

    setCurrentSearchMode(state, action) {
      state.currentSearchMode = action.payload.mode;
    },
  },
});

export const {
  setDateOfJourney,
  getSourceLatLng,
  getDestinationLatLng,
  setTimeOfJourney,
  setNumberOfPassenger,
  getCurrency,
  getDuration,
  setRoutePricingDataOW,
  setRoutePricingDataHR,
  setCurrentSearchMode,
  setisSearchingprice,
  setDropof,
  setPickUp,
  setHour,
  resetroutePricingData,
  setStatus,
} = routePricingSlice.actions;

export const routePricingReducer = routePricingSlice.reducer;
